/**
 * TanStack Query hook for fetching platform stats from GET /v1/platform/stats.
 *
 * Refetches every 60s to match the KV cache TTL on the API side.
 */

import { useQuery } from "@tanstack/react-query";
import { platformApi } from "../../lib/api";
import { platformKeys } from "./query-keys";
export { platformKeys };

export function usePlatformStats() {
	return useQuery({
		queryKey: platformKeys.stats(),
		queryFn: () => platformApi.getStats(),
		staleTime: 60_000,
		refetchInterval: 60_000,
		select: (response) => response.data,
	});
}
